<template>
  <div id="component">

    <div class="fb-page" :data-href="'https://www.facebook.com/' + id" data-tabs="timeline" data-small-header="false" :data-width="maxwidth" data-adapt-container-width="false" data-height="500" data-hide-cover="false" data-show-facepile="true" data-hide-cta="true"><blockquote :cite="id" class="fb-xfbml-parse-ignore"><a :href="id">{{id}}</a></blockquote></div>

  </div>
</template>

<script>
export default {
  name: 'FeedFacebook',
  data () {
    return {
    }
  },
  props: {
    id: "",
    alt: ""
  },
  methods: {
  },
  computed: {
    maxwidth: function() {
      return Math.min(340,window.innerWidth)
    }
  },
  updated: function (){
    //reload();
    (function(d, s, id) {
      var js, fjs = d.getElementsByTagName(s)[0];
      if (d.getElementById(id)) return;
      js = d.createElement(s); js.id = id;
      js.src = 'https://connect.facebook.net/sv_SE/sdk.js#xfbml=1&version=v2.12&appId=1196347747065674&autoLogAppEvents=1';
      fjs.parentNode.insertBefore(js, fjs);
    }(document, 'script', 'facebook-jssdk'));
  }
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>

  #component{
  }

</style>



// WEBPACK FOOTER //
// src/components/FeedFacebook.vue